/**
 * Язык в React.
 *
 * Словарь живёт вне React — он нужен и в местах, где хуков нет. Но
 * компоненты обязаны перерисоваться при смене языка, а простая функция
 * `t()` об этом React не сообщает.
 *
 * Поэтому хук: он подписывается на смену языка и заставляет компонент
 * перерисоваться. Возвращает ту же `t`, чтобы в коде компонентов не
 * появилось двух способов получить строку.
 */

import { useEffect, useSyncExternalStore } from 'react';
import type { LanguageSetting } from '@specter/types';
import { activeLanguage, onLanguageChange, setLanguage, t, type Language } from './index.js';

/** Перерисовка при смене языка. Возвращает функцию перевода. */
export function useT(): typeof t {
  useSyncExternalStore(onLanguageChange, activeLanguage, activeLanguage);
  return t;
}

/** Текущий язык — там, где нужен он сам, а не строка. */
export function useLanguage(): Language {
  return useSyncExternalStore(onLanguageChange, activeLanguage, activeLanguage);
}

/**
 * Применить язык из профиля.
 *
 * Вызывается один раз наверху приложения — там же, где применяется
 * тема: обе настройки приходят из профиля и обе меняют весь экран.
 */
export function useLanguageSetting(setting: LanguageSetting): void {
  useEffect(() => {
    setLanguage(setting);
  }, [setting]);
}
